const MESSAGE_TYPES = {
  ACCOUNT_REMOVAL: 'account-removal',
}

function handleAccountRemoval(doc, rootComponent) {
  rootComponent.$router.push({
    name: 'home',
    query: { error: true },
  })
}

const AccountRemovalWebSocketSubscriber = {
  [MESSAGE_TYPES.ACCOUNT_REMOVAL]: handleAccountRemoval,
}

export default AccountRemovalWebSocketSubscriber
